import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { clearMessage, MESSAGES_KEY } from "../../ducks/message";

import Messages from "./Messages";

const mapStateToProps = (state) => {
  return {
    messages: state.message[MESSAGES_KEY]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      clearMessage
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Messages);
